// DetailsTab.js
import React, {useRef, useState, useEffect, useContext} from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'primereact/tooltip';
import Modal from "../../../Shared/Modal";
import Corridor from "../../Corridor/Corridor";
import {
    getSingleDataMeasurement,
} from "../../../helpers/ApiRequests"
import {useParams} from "react-router-dom";
import {KeycloakContext} from "../../../context/KeycloakContext";
import {Button} from "primereact/button";

// 🔹 Subcomponente reutilizable para cada columna con tooltip
const InfoHeader = ({ target, tooltipContent, label, value }) => {
    return (
        <th className="text-sm text-center bg-transparent border-none py-4 text-white">
            <Tooltip
                target={`.${target}`}
                content={tooltipContent}
                position="left"
                className="tooltip-details"
            />
            <i
                className={`${target} pi pi-info p-1 border-1 text-xxs icon-hover-custom color-primary mr-2 z-5`}
            />
            {label} {Math.round(value * 100)}%
        </th>
    );
}

const DetailsTab = ({ description, ImageFAR, ImageINTERMEDIATE, ImageNEAR, behaviorData, asymmetryData, eyeMovementFactor, eyeDirectionSizeDeg }) => {

    const { t, i18n } = useTranslation();
    const { kc, theme } = useContext(KeycloakContext);
    const [isModalOpen, setModalOpen] = useState(false);
    const [patientData, setPatientData] = useState({});
    const { patientId } = useParams();

    const getSingleDataPatient = async () => {
        setPatientData(await getSingleDataMeasurement(kc, patientId));

    };

    useEffect(() => {
        getSingleDataPatient();
    }, []);

    return (
        <div className="details-tab grid grid-cols-12 gap-2">
            <div className="col-span-12 xl:col-span-3 px-4 ">
                <div className="text-white text-left text-xs color-grey-light uppercase font-bold border-none pb-2"> {t('VerticalAngularRangeMotion')} </div>
                <div className="w-full sm:w-2/5 md:w-2/5 md:w-3/5 lg:w-3/5 m-auto xl:w-full relative">
                    <textarea
                        rows={10}
                        readOnly={true}
                        className="vertical-angular-range-motion w-full border-1 border-grey-ligth text-xs rounded-lg py-3 px-3 "
                        value=""/>
                    <div className="vertical-angular-range-motion-degrees absolute text-white">{ (Math.round(description.GazAngleNearDeg * 10) / 10).toFixed(1) } º</div>
                </div>
                <div className="w-full sm:w-2/5 md:w-2/5 md:w-3/5 lg:w-3/5 m-auto xl:w-full mt-2">
                    <div className="w-full border-1 border-grey-ligth text-xs rounded-lg py-3 px-3 text-left text-white bg-readonly">
                        <div className="txt-readonly">{t('visualDetailTextDefault')}</div>
                        <div className="pt-4 text-center" onClick={() => setModalOpen(true)}>
                            <Button className="btn-1 uppercase">{t('MiCorridor')}</Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-span-12 xl:col-span-9 px-0 pt-5 lg:pt-0 lg:mt-3 xl:-mt-7 z-5">
                <div className="overflow-x-auto">
                    <table className="table-auto w-full border-none">
                        <thead className="bg-transparent">
                        <tr>
                            <th className="bg-transparent border-none"></th>
                            <InfoHeader
                                target="custom-target-icon"
                                tooltipContent={description.DetailsBehaviourDescription_far}
                                label={t('far')}
                                value={eyeMovementFactor?.far}
                            />

                            <InfoHeader
                                target="custom-target-icon-2"
                                tooltipContent={description.DetailsBehaviourDescription_intermediate}
                                label={t('intermediate')}
                                value={eyeMovementFactor?.intermediate}
                            />

                            <InfoHeader
                                target="custom-target-icon-3"
                                tooltipContent={description.DetailsBehaviourDescription_near}
                                label={t('near')}
                                value={eyeMovementFactor?.near}
                            />
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className="border-none"></td>
                            <td className="text-center border-none py-4">
                                <img
                                    src={ImageFAR.src}
                                    alt={ImageFAR.title}
                                    className="w-56 h-auto m-auto"
                                    style={{
                                        backgroundImage: `url(${ImageFAR.bg})`,
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                    }}
                                />
                            </td>
                            <td className="text-center border-none py-4">
                                <img
                                    src={ImageINTERMEDIATE.src}
                                    alt={ImageINTERMEDIATE.title}
                                    className="w-56 h-auto m-auto"
                                    style={{
                                        backgroundImage: `url(${ImageINTERMEDIATE.bg})`,
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                    }}
                                />
                            </td>
                            <td className="text-center border-none py-4">
                                <img
                                    src={ImageNEAR.src}
                                    alt={ImageNEAR.title}
                                    className="w-56 h-auto m-auto"
                                    style={{
                                        backgroundImage: `url(${ImageNEAR.bg})`,
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                    }}
                                />
                            </td>
                        </tr>
                        <tr className="border-none">
                            <td className="text-white text-right text-xs color-grey-light uppercase font-bold border-none">{t('behaviour')}</td>
                            <td className="text-center border-none">
                                <input
                                    value={description.SimpleBehaviourDescription_far_response}
                                    readOnly={true}
                                    className="border-grey-ligth shadow text-center text-sm appearance-none border rounded xl:w-3/4 py-2 px-3"
                                    id="motion"
                                    type="text"
                                />
                            </td>
                            <td className="text-center border-none">
                                <input
                                    value={description.SimpleBehaviourDescription_intermediate_response}
                                    readOnly={true}
                                    className="border-grey-ligth shadow text-center text-sm appearance-none border rounded xl:w-3/4 py-2 px-3"
                                    id="motion"
                                    type="text"
                                />
                            </td>
                            <td className="text-center border-none">
                                <input
                                    value={description.SimpleBehaviourDescription_near_response}
                                    readOnly={true}
                                    className="border-grey-ligth shadow text-center text-sm appearance-none border rounded xl:w-3/4 py-2 px-3"
                                    id="motion"
                                    type="text"
                                />
                            </td>
                        </tr>
                        <tr className="border-none">
                            <td className="text-white text-right text-xs color-grey-light uppercase font-bold border-none">{t('orientation')}</td>
                            <td className="text-center border-none">
                                <input
                                    value={description.SimpleBehaviourDescription_far_asymmetry}
                                    readOnly={true}
                                    className="border-grey-ligth shadow text-center text-sm appearance-none border rounded xl:w-3/4 py-2 px-3"
                                    id="motion"
                                    type="text"
                                />
                            </td>
                            <td className="text-center border-none">
                                <input
                                    value={description.SimpleBehaviourDescription_intermediate_asymmetry}
                                    readOnly={true}
                                    className="border-grey-ligth shadow text-center text-sm appearance-none border rounded xl:w-3/4 py-2 px-3"
                                    id="motion"
                                    type="text"
                                />
                            </td>
                            <td className="text-center border-none">
                                <input
                                    value={description.SimpleBehaviourDescription_near_asymmetry}
                                    readOnly={true}
                                    className="border-grey-ligth shadow text-center text-sm appearance-none border rounded xl:w-3/4 py-2 px-3"
                                    id="motion"
                                    type="text"
                                />
                            </td>
                        </tr>
                        <tr className="border-none">
                            <td className="text-white text-right text-xs color-grey-light uppercase font-bold border-none">{t('HorizontalAngularRangeMotion')}</td>
                            <td className="text-center border-none">
                                <input
                                    value={Math.round(eyeDirectionSizeDeg?.far?.horizontal) + " º"}
                                    readOnly={true}
                                    className="border-grey-ligth shadow text-center text-sm appearance-none border rounded xl:w-3/4 py-2 px-3"
                                    id="motion"
                                    type="text"
                                />
                            </td>
                            <td className="text-center border-none">
                                <input
                                    value={Math.round(eyeDirectionSizeDeg?.intermediate?.horizontal) + " º"}
                                    readOnly={true}
                                    className="border-grey-ligth shadow text-center text-sm appearance-none border rounded xl:w-3/4 py-2 px-3"
                                    id="motion"
                                    type="text"
                                />
                            </td>
                            <td className="text-center border-none">
                                <input
                                    value={Math.round(eyeDirectionSizeDeg?.near?.horizontal) + " º"}
                                    readOnly={true}
                                    className="border-grey-ligth shadow text-center text-sm appearance-none border rounded xl:w-3/4 py-2 px-3"
                                    id="motion"
                                    type="text"
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            {isModalOpen && (
                <Modal themeClass={theme}>
                    <Corridor onClose={() => setModalOpen(false)} data={patientData} reference_id={patientId} theme={theme} />
                </Modal>
            )}
        </div>
    );
};
const classes = `text-xs p-2 col-span-1 md:col-span-2 w-48 sm:60 md:w-72 lg:w-80 xl:w-80 2xl:w-96`

export default DetailsTab;
